import React, { Component } from "react";
import { loadModules } from 'esri-loader';

class FacilityMiniMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      facilityLayer: []
    };
    this.mapRef = React.createRef();
  }

  //Google Maps
  // render() {
  //   const minimap = (
  //     <MiniMap
  //       facSt1={this.props.FAC_ST1}
  //       facCity={this.props.FAC_CITY}
  //       facState={this.props.FAC_STATE}
  //       facLat={this.props.DD_Latitude}
  //       facLong={this.props.DD_Longitude}
  //     />
  //   );

  //   return <div>{minimap}</div>;
  // }

  //ArcGIS Map
  createFacilities = () => {
    loadModules(['esri/layers/FeatureLayer', 'esri/layers/support/Field', 'esri/symbols/TextSymbol', 'esri/symbols/WebStyleSymbol']).then(([FeatureLayer, Field, TextSymbol, WebStyleSymbol]) => {

      // const textSymbol = new TextSymbol({
      //   color: '#7A003C',
      //   angle: 180,
      //   fillColor: '#7A003C',
      //   text: '\ue61d',  // esri-icon-map-pin
      //   font: {  // autocast as new Font()
      //     size: 24,
      //     family: 'CalciteWebCoreIcons'
      //   }
      // });


      //https://developers.arcgis.com/javascript/latest/guide/esri-web-style-symbols-2d/
      var webStyleSymbol = new WebStyleSymbol({
        name: "push-pin-2",
        color: "#7A003C",
        styleName: "Esri2DPointSymbolsStyle"
      });

      const facilityRenderer = {
        type: "simple",
        // symbol: {
        //   type: "simple-marker",
        //   size: 8,
        //   //color:[0, 255, 255],
        //   color: [255, 0, 0],
        //   outline: null
        // }
        //symbol: textSymbol
        symbol: webStyleSymbol
      };

      const fields = [
        new Field({
          name: "ObjectID",
          alias: "ObjectID",
          type: "oid"
        }),
        new Field({
          name: "FacName",
          alias: "FacName",
          type: "string"
        }),
        new Field({
          name: "EpaId",
          alias: "EpaId",
          type: "string"
        })
      ];

      const facilities = []
      const facility =
      {
        geometry: {
          type: "point",
          x: this.props.DD_Longitude,
          y: this.props.DD_Latitude
        },
        attributes: {
          ObjectID: 0,
          EpaId: this.props.EPA_ID
        }
      };
      facilities.push(facility);

      const facilityLayer = new FeatureLayer({
        title: 'facility layer',
        source: facilities,
        fields: fields,
        ObjectIDField: 'ObjectID',
        renderer: facilityRenderer,
        //popupTemplate: facilitiesPopup
      });

      this.setState({
        facilityLayer: facilityLayer
      }, () => {
        this.state.map.add(this.state.facilityLayer);
      });
    }).catch((err) => console.error(err));

  }

  createMap = () => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(['esri/WebMap', 'esri/views/MapView', 'esri/Basemap', 'esri/widgets/BasemapToggle'], { css: true })
      .then(([WebMap, MapView, Basemap, BasemapToggle]) => {

        const map = new WebMap({
          // portalItem: {
          //   id: 'da83595b291349b79c7e56e5fabc5fde'
          // },
          // basemap: Basemap.fromId("streets-night-vector"),
          basemap: Basemap.fromId("streets-navigation-vector"),
        });

        this.setState({
          map: map,
        }, () => {
          this.createFacilities();
        });

        //2d View
        this.view = new MapView({
          container: this.mapRef.current,
          map: this.state.map,
          center: [this.props.DD_Longitude, this.props.DD_Latitude],
          zoom: 15,
          highlightOptions: {
            fillOpacity: 0,
            color: [50, 50, 50]
          },
          popup: {
            dockEnabled: true,
            dockOptions: {
              position: "top-right",
              breakpoint: false
            }
          },
          // constraints: {
          //   maxScale: 35000,
          //   minScale: 10000000
          // }
        });

        var basemapToggle = new BasemapToggle({
          view: this.view,
          nextBasemap: "hybrid"
        });
        this.view.ui.add(basemapToggle, "bottom-left");

      });
    this.setState({
      view: this.view
    });
  }
  componentDidMount() {
    this.createMap();
  }

  componentDidUpdate() {
  }

  render() {
    return (
      <div>
        <div className="" style={{ position: "relative" }}>
          <div className="webmap" ref={this.mapRef} style={{ height: '250px' }} />
        </div>
      </div>
    );
  }
}

export default FacilityMiniMap;
